<template>
  <div class="container">
    <moduleTitle title="填写简历" class="bottom"></moduleTitle>
    <resumeInfo :disabled="false"></resumeInfo>
  </div>
</template>
<style lang="scss" scoped>
.container {
  width: 80%;
  margin: 40px auto;
  .bottom {
    margin-bottom: 40px;
  }
}
</style>
<script>
import resumeInfo from "./components/resumeInfo";
import moduleTitle from "@/components/moduleTitle";
export default {
  components: {
    resumeInfo,
    moduleTitle
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
